import { STAGES } from "../../../utils/stageManagement";
import { navItems } from "./packageBuilderConfig";

const isItineraryDayComplete = (day) => Number(day?.is_completed) === 1;

export const getPackageCompletedStage = (
  generalInfoData,
  { itineraryDays = [], expectedDayCount = 0 } = {}
) => {
  const savedStage = Number(generalInfoData?.current_stage) || 0;
  let stage = savedStage || STAGES.GENERAL;

  if (!Array.isArray(itineraryDays) || itineraryDays.length === 0) {
    return stage;
  }

  const allDaysComplete =
    itineraryDays.length > 0 && itineraryDays.every(isItineraryDayComplete);
  const hasExpectedDays =
    !expectedDayCount || itineraryDays.length >= Number(expectedDayCount);

  if (allDaysComplete && hasExpectedDays) {
    stage = Math.max(stage, STAGES.STAY);
  }

  return stage;
};

export const isPackageSectionAccessible = (
  targetStage,
  completedStage,
  hasPackageId
) => {
  if (!hasPackageId) {
    return Number(targetStage) === STAGES.GENERAL;
  }
  let progress = Number(completedStage) || STAGES.GENERAL;
  // Once general is saved (package exists), itinerary must be reachable even if
  // current_stage was not advanced correctly on an earlier save.
  if (progress < STAGES.ITINERARY) {
    progress = STAGES.ITINERARY;
  }
  return Number(targetStage) <= progress;
};

export const getPackageResumeSectionId = (completedStage) => {
  const stage = Number(completedStage) || STAGES.GENERAL;
  const match = navItems.find((item) => item.stage === stage);
  if (match) return match.id;

  const pending = navItems.find((item) => item.stage > stage);
  return pending?.id || navItems[navItems.length - 1]?.id || "general";
};

export const hasCancellationContent = (cancellationData) => {
  if (!cancellationData?.data?.length) return false;

  return cancellationData.data.some((rule) => {
    const refund = rule.refund_percentage;
    const hasRefund =
      refund !== "" && refund !== null && refund !== undefined;

    if (!hasRefund) return false;

    if (rule.days_type === "days_range") {
      return (
        Boolean(rule.cancellation_days_from) &&
        Boolean(rule.cancellation_days_to)
      );
    }

    return Boolean(rule.cancellation_days);
  });
};
